import { getSubdomain } from "modules/core/utils/helpers";
import { fetchAIAuthToken } from "../api/auth";
import {
  getFromLocalStorage,
  setInLocalStorage
} from "modules/core/utils/localStorage";

export const getAIAuthToken = async () => {
  const tenant = getSubdomain();
  const localStorageKey = `ef_ai_at:${tenant}`;
  let token = "";

  const cachedTokenData = getFromLocalStorage<{
    token: string;
    expires_at: number;
  }>(localStorageKey);

  if (!cachedTokenData || cachedTokenData.expires_at <= Date.now()) {
    const freshTokenData = await fetchAIAuthToken();

    token = freshTokenData.token;

    setInLocalStorage(localStorageKey, {
      token: freshTokenData.token,
      expires_at: freshTokenData.expires_at
    });
  } else {
    token = cachedTokenData.token;
  }

  return token;
};
